import { ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { BrowserRouter as Router, useLocation } from "react-router-dom";

import { IndexRouter } from "./setup/routes/routes";
import { ScrollToTop } from "./components/common/scrollToTop";
import theme from "./styles/common/theme/theme";
import Sidebar from "./pages/business/sidebar";
import { isLoggedIn } from "./setup/context/authContext";
import "./App.css";
import AlertSystem from "./components/common/AlertSystem/AlertSystem";
import { ROUTES } from "./setup/constants";
import OrganizationGate from "./components/organization/OrganizationGate";
import { TWO_PARTY_CONTRACT_BASE_ROUTE } from "./setup/util/twoPartyContract";

// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const hideSidebarRoutes = [
  ROUTES.CREATE_COMPLEX_CONTRACT.replace(":milestoneId?", "").replace(
    ":complexId?/",
    ""
  ),
  TWO_PARTY_CONTRACT_BASE_ROUTE,
  ROUTES.CONTRACT,
  ROUTES.SETTLEMENTS,
];
const whiteBackgroundRoutes = [
  ROUTES.CREATE_COMPLEX_CONTRACT.replace(":milestoneId?", "").replace(
    ":complexId?/",
    ""
  ),
  TWO_PARTY_CONTRACT_BASE_ROUTE,
  ROUTES.CONTRACT,
  ROUTES.SETTLEMENTS,
];

export const App = () => {
  function SidebarContainer() {
    const location = useLocation();
    const isHideSidebar = hideSidebarRoutes.some((route) =>
      location?.pathname?.includes(route)
    );
    if (isHideSidebar) return null;
    return isLoggedIn() ? <Sidebar /> : null;
  }

  function MainContainer() {
    const location = useLocation();
    const isWhiteBackground = whiteBackgroundRoutes.some((route) =>
      location?.pathname?.includes(route)
    );
    const content = (
      <>
        <SidebarContainer />
        <div className={!isLoggedIn() ? undefined : "outletContainer"}>
          <IndexRouter />
        </div>
      </>
    );

    // Layout lives in App.css (.appShell) so it can stack on narrow viewports, where the
    // sidebar reflows into a top bar; only the route-dependent background stays inline.
    return (
      <div
        className={isLoggedIn() ? "appShell" : undefined}
        style={
          isLoggedIn() && isWhiteBackground
            ? { background: "white" }
            : undefined
        }>
        {isLoggedIn() ? (
          <OrganizationGate>{content}</OrganizationGate>
        ) : (
          content
        )}
      </div>
    );
  }

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <div dir="rtl">
          <ScrollToTop path="/">
            <Router>
              <MainContainer />
            </Router>
          </ScrollToTop>
          <AlertSystem />
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
};
